/**
 * Router.js por módulo 
 * 
 * @author Daniel Lepe
 * @version 1.0
 * @date 14/03/2024
 */
 
const rootPath = '/Requestcache',
    rootName = 'Caché de solicitudes',
    indexUri = 'index';

const router = {
    path: rootPath,
    redirect: rootPath + '/' + indexUri,
    component: () => import('@/containers/DefaultContainer'),
    children: [
        {
            path: indexUri,
            name: rootName,
            component: () => import('./RequestcacheQuicktable.vue')
        }
    ]
}

// EASYLUNCH
const nav = {
    name: rootName,
    url: rootPath,
    icon: 'fa fa-cog'
}

export {
    rootPath, rootName,
    router,
    nav
}